import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupOctopusGroup } from "./octopus";

const OctopusSetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const OctopusSetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Fresh section per catalog build - see network/section.ts for the rationale.
export const octopusScanners = (): Section => {
  const octopusScanners = new Section("octopus_scanner", [
    new Translation("en", "Octopus Scanners"),
    new Translation("en", "Octopus-Scanner"),
  ]);
  octopusScanners.help = [
    new Translation(
      "en",
      `Add Octopus to get more detailed information about their API!`
    ),
    new Translation(
      "de",
      `Fügen Sie Octopus hinzu, um detailliertere Informationen über deren API zu erhalten!`
    ),
  ];

  octopusScanners.description = [
    new Translation("en", OctopusSetupEn),
    new Translation("de", OctopusSetupDe),
  ];

  setupOctopusGroup(octopusScanners, 0);
  return octopusScanners;
};
